import { Component, OnInit, ViewChild, ElementRef, Input, Output, QueryList, EventEmitter, NgZone } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, AbstractControl, Validators, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { LeadService } from '@shared/services/leads/leads.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-address-popup',
  templateUrl: './address-popup.component.html',
  styleUrls: ['./address-popup.component.css']
})
export class AddressPopupComponent implements OnInit {
  @ViewChild('contentAddress') modal: ElementRef;
  @ViewChild('search') public searchElementRef: QueryList<ElementRef>;
  modalRef: NgbModalRef;
  address: string;
  street: string;
  houseno: string;
  state: string;
  borough: string;
  zipcode: string;
  addressForm: FormGroup;
  address_type_id: number;
  addresstype: string;
  id: number;
  completeaddress: string;
  latitude: number;
  longitude: number;
  errorMsg = false;
  initAutoComplete = false;
  @Output() onUpdateAddress: EventEmitter<any> = new EventEmitter();
  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private leadService: LeadService,
    private route: ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
  ) {
    this.route.params.subscribe(params => {
      this.id = params['addressId'];

    })
  }

  ngOnInit() {
    this.createForm();
  }
  createForm() {
    this.addressForm = this.formBuilder.group({
      'houseno': [null],
      'apartment': [null],
      'street': [null],
      'borough': [null],
      'city': [null],
      'state': [null],
      'zipcode': [null],
      'completeaddress': [null]
    });
  }
  // showModal(lead,type) {
  //
  //   if(type=='permittee'){
  //     this.address=lead.permittee_address;
  //   }else{
  //     this.address=lead.owners_house+" "+lead.owners_house_street_name+","+lead.owner_city+","+lead.owner_state+","+lead.owners_zip_code;
  //   }

  //   this.modalRef = this.modalService.open(this.modal, { windowClass: 'address-modal' });
  //   this.modalRef.result.then((data) => {
  //
  //   }, (reason) => {
  //
  //   });
  // }

  showModal(leaddetail, type) {


    // this.houseno=leaddetail.lead_house;
    // this.street=leaddetail.lead_street_name;
    // this.borough=leaddetail.lead_borrow;
    // this.state=leaddetail.lead_state;
    // this.zipcode=leaddetail.lead_zip;

    this.modalRef = this.modalService.open(this.modal, { windowClass: 'address-modal' });
    // this.modalRef.result.then((data) => {
    //
    // }, (reason) => {
    //
    // });
    if (type == 'lead') {
      this.completeaddress =
      (leaddetail.lead_house == null || leaddetail.lead_house == '' ? '' : leaddetail.lead_house + ",") +
        (leaddetail.lead_street_name == null || leaddetail.lead_street_name == '' ? '' : leaddetail.lead_street_name + ",") +
        (leaddetail.lead_apt_no == null || leaddetail.lead_apt_no == '' ? '' : leaddetail.lead_apt_no + ",") +
        (leaddetail.lead_borrow == null || leaddetail.lead_borrow == '' ? '' : leaddetail.lead_borrow + ",") +
        (leaddetail.lead_city == null || leaddetail.lead_city == '' ? '' : leaddetail.lead_city + ', ') +
        (leaddetail.lead_state == null || leaddetail.lead_state == '' ? '' : leaddetail.lead_state + ', ') +
        (leaddetail.lead_zip == null || leaddetail.lead_zip == '' ? '' : leaddetail.lead_zip + ', ')

      this.address_type_id = leaddetail.lead_addr_id;
      this.addresstype = 'lead_address';
      this.addressForm.controls['houseno'].setValue(leaddetail.lead_house, { onlySelf: true });
      this.addressForm.controls['apartment'].setValue(leaddetail.lead_apt_no, { onlySelf: true });
      this.addressForm.controls['street'].setValue(leaddetail.lead_street_name, { onlySelf: true });
      this.addressForm.controls['borough'].setValue(leaddetail.lead_borrow, { onlySelf: true });
      this.addressForm.controls['city'].setValue(leaddetail.lead_city, { onlySelf: true });
      this.addressForm.controls['state'].setValue(leaddetail.lead_state, { onlySelf: true });
      this.addressForm.controls['zipcode'].setValue(leaddetail.lead_zip, { onlySelf: true });
    } else if (type == 'owner') {

      this.completeaddress =
      (leaddetail.owners_house != "" && leaddetail.owners_house != null ? leaddetail.owners_house + "," : '') +
      (leaddetail.owners_house_street_name != "" && leaddetail.owners_house_street_name != null ? leaddetail.owners_house_street_name + "," : '') +
      (leaddetail.owner_apt_no != "" && leaddetail.owner_apt_no != null ? leaddetail.owner_apt_no + "," : '') +
      (leaddetail.owner_borrow != "" && leaddetail.owner_borrow != null ? leaddetail.owner_borrow + "," : '') +
      (leaddetail.owner_city != "" && leaddetail.owner_city != null ? leaddetail.owner_city + "," : '') +
      (leaddetail.owner_state != "" && leaddetail.owner_state != null ? leaddetail.owner_state + "," : '') +
      (leaddetail.owners_zip_code);
      this.address_type_id = leaddetail.owner_id;
      this.addresstype = 'owner_address';
      setTimeout(() => { this.autoPlaces(); }, 1000);
      this.addressForm.controls['completeaddress'].setValue(this.completeaddress, { onlySelf: true });
      this.addressForm.controls['houseno'].setValue(leaddetail.owners_house, { onlySelf: true });
      // this.addressForm.controls['apartment'].setValue(leaddetail.lead_house, { onlySelf: true });
      this.addressForm.controls['street'].setValue(leaddetail.owners_house_street_name, { onlySelf: true });
      if (leaddetail.owner_borrow) {
        this.addressForm.controls['borough'].setValue(leaddetail.owner_borrow, { onlySelf: true });
      } else {
        this.addressForm.controls['borough'].setValue('', { onlySelf: true });
      }
      if (leaddetail.owner_apt_no) {
        this.addressForm.controls['apartment'].setValue(leaddetail.owner_apt_no, { onlySelf: true });
      } else {
        this.addressForm.controls['apartment'].setValue('', { onlySelf: true });
      }
      this.addressForm.controls['city'].setValue(leaddetail.owner_city, { onlySelf: true });
      this.addressForm.controls['state'].setValue(leaddetail.owner_state, { onlySelf: true });
      this.addressForm.controls['zipcode'].setValue(leaddetail.owners_zip_code, { onlySelf: true });
    } else if (type == 'permittee') {

      this.addresstype = 'permittee_address';
      this.address_type_id = leaddetail.permittee_id;
      if (leaddetail.permittee_zip_code) {
        this.completeaddress =
          (leaddetail.permittee_house == null || leaddetail.permittee_house == '' ? '' : leaddetail.permittee_house)
          + (leaddetail.permittee_house_street_name == null || leaddetail.permittee_house_street_name == '' ? '' : leaddetail.permittee_house_street_name + ",")
          + (leaddetail.permittee_apt_no == null || leaddetail.permittee_apt_no == '' ? '' : leaddetail.permittee_apt_no + ',')
          + (leaddetail.permittee_borrow == null || leaddetail.permittee_borrow ? '' : leaddetail.permittee_borrow + ",")
          + (leaddetail.permittee_city == null || leaddetail.permittee_city == '' ? '' : leaddetail.permittee_city + ",")
          + (leaddetail.permittee_state == null || leaddetail.permittee_state == '' ? '' : leaddetail.permittee_state + ",")
          + (leaddetail.permittee_zip_code == null || leaddetail.permittee_zip_code == '' ? '' : leaddetail.permittee_zip_code);
          setTimeout(() => { this.autoPlaces(); }, 1000);
        this.addressForm.controls['completeaddress'].setValue(this.completeaddress, { onlySelf: true });
        this.addressForm.controls['houseno'].setValue(leaddetail.permittee_house, { onlySelf: true });

        if (leaddetail.permittee_apt_no) {
          this.addressForm.controls['apartment'].setValue(leaddetail.permittee_apt_no, { onlySelf: true });
        } else {
          this.addressForm.controls['apartment'].setValue('', { onlySelf: true });
        }

        this.addressForm.controls['street'].setValue(leaddetail.permittee_house_street_name, { onlySelf: true });
        this.addressForm.controls['borough'].setValue(leaddetail.permittee_borrow, { onlySelf: true });
        this.addressForm.controls['city'].setValue(leaddetail.permittee_city, { onlySelf: true });
        this.addressForm.controls['state'].setValue(leaddetail.permittee_state, { onlySelf: true });
        this.addressForm.controls['zipcode'].setValue(leaddetail.permittee_zip_code, { onlySelf: true });
      } else if(leaddetail.permittee_address){
        this.completeaddress = leaddetail.permittee_address;
        var address = leaddetail.permittee_address.trim();

        // var str = '138 WEST 18TH STREET BKLYN NEW YORK NY 10011';
        var zipcode = address.match(/\d+$/);
        //
        if(zipcode){
          var address = address.replace(zipcode[0], "");
        }

        var home = address.trimLeft().match(/^[\d]+-[\d]+\s|[\d]+\s/g);
        if(home){
          var address = address.replace(home[0], "");
        }
        var address = address.trim();
        var arr = address.split(' ');
        var state = arr[arr.length - 1];
        var address = address.replace(state, "");
        var borough = ['BRONX', 'BKLYN', 'BROOKLYN', 'QUEENS', 'MANHATTAN', 'STATEN ISLAND'];
        for (var i = 0; i <= borough.length; i++) {
          if (address.includes(borough[i])) {
            var b = borough[i];
            var address = address.replace(b, '');
            break;
          }
          var b = '';
        }
        var city = ["NEW YORK"];
        for (var i = 0; i <= city.length; i++) {
          if (address.includes(city[i])) {
            var c = city[i];
            var address = address.replace(c, '');
            break;
          }
          var c = '';
        }
        // this.autoPlaces();
        setTimeout(() => { this.autoPlaces(); }, 1000);
        this.addressForm.controls['completeaddress'].setValue(this.completeaddress, { onlySelf: true });
        if(home){
          this.addressForm.controls['houseno'].setValue(home[0], { onlySelf: true });
        }else{
          this.addressForm.controls['houseno'].setValue('', { onlySelf: true });
        }

        this.addressForm.controls['apartment'].setValue('', { onlySelf: true });
        this.addressForm.controls['street'].setValue(address, { onlySelf: true });
        this.addressForm.controls['borough'].setValue(b, { onlySelf: true });
        this.addressForm.controls['city'].setValue(c, { onlySelf: true });
        this.addressForm.controls['state'].setValue(state, { onlySelf: true });
        if(zipcode){
          this.addressForm.controls['zipcode'].setValue(zipcode[0], { onlySelf: true });
        }else{
          this.addressForm.controls['zipcode'].setValue('', { onlySelf: true });
        }
      }else{

        setTimeout(() => { this.autoPlaces(); }, 1000);
        this.addressForm.controls['completeaddress'].setValue('', { onlySelf: true });
        this.addressForm.controls['houseno'].setValue('', { onlySelf: true });
        this.addressForm.controls['apartment'].setValue('', { onlySelf: true });
        this.addressForm.controls['street'].setValue('', { onlySelf: true });
        this.addressForm.controls['borough'].setValue('', { onlySelf: true });
        this.addressForm.controls['city'].setValue('', { onlySelf: true });
        this.addressForm.controls['state'].setValue('', { onlySelf: true });
        this.addressForm.controls['zipcode'].setValue('', { onlySelf: true });
      }
    }

  }
  autoPlaces() {
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(<HTMLInputElement>document.getElementById('completeaddress'), {
        types: ['address'],
        componentRestrictions: { country: 'us' }
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {

            return;
          }
          let addressData = this.createAddressData(place);



          this.addressForm.controls['houseno'].setValue(addressData['street_no'], { onlySelf: true });
          this.addressForm.controls['apartment'].setValue('', { onlySelf: true });
          this.addressForm.controls['street'].setValue(addressData['address1'], { onlySelf: true });
          this.addressForm.controls['borough'].setValue(addressData['address2'], { onlySelf: true });
          this.addressForm.controls['city'].setValue(addressData['city'], { onlySelf: true });
          this.addressForm.controls['state'].setValue(addressData['state'], { onlySelf: true });
          this.addressForm.controls['zipcode'].setValue(addressData['zip'], { onlySelf: true });

          // let addr1 = (addressData['street_no'] == null ? '' : addressData['street_no'] + ', ') +
          //   (addressData['address1'] == null ? '' : addressData['address1'] + ', ') + (addressData['address2'] == null ? '' :
          //     addressData['address2'] + ', ') + (addressData['city'] == null ? '' : addressData['city'] + ', ') +
          //   (addressData['state'] == null ? '' : addressData['state'] + ', ') + (addressData['country'] == null ? '' :
          //     addressData['country'] + ', ') + (addressData['zip'] == null ? '' : addressData['zip']);
          //
          // addr1 = addr1.replace(/,(\s+)?$/, "");
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();

        });
      });
    });
  }
  createAddressData(place) {

    let addressData = {};

    for (var ac = 0; ac < place.address_components.length; ac++) {
      var component = place.address_components[ac];
      switch (component.types[0]) {
        case "route":
          addressData['address1'] = component.long_name;
          break;

        case "sublocality_level_2":
          addressData['address2'] = component.long_name;
          break;

        case "sublocality_level_1":
          if (addressData['address2']) {
            addressData['address2'] = addressData['address2'] + ", " + component.long_name;
          } else {
            addressData['address2'] = component.long_name;
          }

          break;

        case "postal_code":
          addressData['zip'] = component.long_name;
          break;

        case 'locality':
          addressData['city'] = component.long_name;
          break;

        case 'administrative_area_level_1':
          addressData['state'] = component.long_name;
          break;
        case 'country':
          addressData['country'] = component.long_name;
          break;
        case "street_number":
          addressData['street_no'] = component.long_name;
          break;
      }
    };

    addressData['latitude'] = place.geometry.location.lat();
    addressData['longitude'] = place.geometry.location.lng();


    return addressData;
  }
  updateAddress() {
    this.errorMsg = false;
    if(this.addressForm.controls['zipcode'].value == '') {
      this.errorMsg = true;
      return;
    }
    const address = {
      'addr_type_id': this.address_type_id,
      'house': this.addressForm.controls['houseno'].value,
      'apt_no': this.addressForm.controls['apartment'].value,
      'street_name': this.addressForm.controls['street'].value,
      'borrow': this.addressForm.controls['borough'].value,
      'city': this.addressForm.controls['city'].value,
      'state': this.addressForm.controls['state'].value,
      'zip': this.addressForm.controls['zipcode'].value,
      'addr_type': this.addresstype,
      'latitude': this.latitude,
      'longitude': this.longitude
    };
    this.leadService.updateAddress(address)
      .subscribe(result => {
        this.modalRef.close();
        this.createForm();
        this.onUpdateAddress.emit(this.id);

      })

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/address-popup/address-popup.component.ts